import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";

import Slide from "@mui/material/Slide";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {
  AppBar,
  Autocomplete,
  Avatar,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import config from "../../../Data/AuthUser";
import {
  AgentSettingsApi,
  groupSettingsApi,
  LeadAgentsSettingsApi,
} from "../../../Data/axios";
import { useEffect } from "react";
import { useState } from "react";
import StatusAlert from "../../../StatusAlertList/StatusAlert";

import { Theme, useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";

import FormControl from "@mui/material/FormControl";
import { SelectChangeEvent } from "@mui/material/Select";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AgentsDailog({ setOfficecode, setCountry, onAgentSaved }) {
  const [open, setOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const [showData, setShowData] = React.useState([]);
  const [showGroup, setShowGroup] = React.useState([]);
  const [agentData, setAgentData] = React.useState("");
  const [agentGroup, setAgentGroup] = React.useState("");
  const [leadSource, setLeadSource] = useState([]);
  const [agentsMain, setAgentsMain] = React.useState([]);
  const [selectedAgent, setSelectedAgent] = React.useState({
    empid: null,
  });
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    const fetchAgents = async () => {
      setLoading(true);
      try {
        const data = await LeadAgentsSettingsApi.getEmployee();
        // Handle both direct array and wrapped response formats
        const agentsArray = Array.isArray(data) ? data : (data?.data || []);
        setAgentsMain(agentsArray);
      } catch (error) {
        console.error("Error fetching agents:", error);
        setAgentsMain([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAgents();
  }, []);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      const response = await groupSettingsApi.getAll();
      // Handle both direct array and wrapped response formats
      const groupsArray = Array.isArray(response) ? response : (response?.data || []);
      setLeadSource(groupsArray);
    } catch (error) {
      console.error("Error fetching lead sources:", error);
      setLeadSource([]); // Set to empty array on error
    }
  }

  const personalName = Array.isArray(personName) ? personName.map((item) => item.toString()) : [];
  const groupIds = Array.isArray(leadSource)
    ? leadSource
        .filter((group) => group && group.ticket_group && personalName.includes(group.ticket_group))
        .map((group) => group.id.toString())
    : [];

  const item = {
    agent_id: selectedAgent.empid,
    group_id: groupIds,
  };
  async function SaveDate() {
    console.log(item, "item got");

    try {
      const formData = new FormData();
      for (const key in item) {
        if (item[key] !== undefined && item[key] !== null) {
          formData.append(key, item[key]);
        }
      }
      await AgentSettingsApi.add(formData);
      showAlert(" Added Successfully!", "success");
      setOpen(false);
      onAgentSaved?.(); // Call the refresh callback if provided
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert("Failed to add Ticket Group", "error");
    }
  }

  return (
    <React.Fragment>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <Box
        onClick={handleClickOpen}
        sx={{
          backgroundColor: "#1d82f5",
          "&:hover": { backgroundColor: "orange" },
          textAlign: "center",
          padding: "10px",
          marginLeft: "10px",
          height: "40px",
          width: "115px",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          borderRadius: "4px",
          fontSize: "15px",
          fontFamily: "sans-serif",
          cursor: "pointer",
        }}
      >
        <AddIcon />
        Add Agent
      </Box>

      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        TransitionComponent={Transition}
        onClose={handleClose}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#141b2d",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon fontSize="large" />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1, fontSize: "18px" }}
              component="div"
            >
              New Agent
            </Typography>
          </Toolbar> {/* Closing tag added here */}
        </AppBar> {/* Closing tag for AppBar added here */}
        <Box sx={{ margin: "20px" }}>
          <Grid
            container
            spacing={2}
            style={{
              color: "black",
              width: "100%",
              paddingLeft: "20px",
            }}
          >
            <Grid item xs={12} sm={6} md={6}>
              <Stack direction="column">
                <Typography> Agent Choose</Typography>

                <Autocomplete
                  options={agentsMain}
                  getOptionLabel={(option) => option.empid || ""}
                  value={selectedAgent}
                  onChange={(event, value) => setSelectedAgent(value)}
                  loading={loading}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search for an agent"
                      variant="outlined"
                      fullWidth
                      sx={{
                        marginTop: "5px",
                        border: 1,
                        borderRadius: 1,
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black",
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        style: { color: "black" },
                        endAdornment: (
                          <>
                            {loading ? <CircularProgress size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  renderOption={(props, option) => {
                    const imageUrl = `${config.apiImageUrl}${option.image}`;
                    return (
                      <Box
                        {...props}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                      >
                        <Avatar
                          src={imageUrl}
                          alt={option.name}
                          sx={{
                            width: 30,
                            height: 30,
                            marginRight: "10px",
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography>
                            {option.name}
                            {option.isYou && (
                              <Typography
                                component="span"
                                sx={{
                                  fontSize: "0.8rem",
                                  fontWeight: "normal",
                                  color: "#888",
                                  marginLeft: "5px",
                                }}
                              >
                                (It’s you)
                              </Typography>
                            )}
                          </Typography>
                          <Typography>{option.empid}</Typography>
                        </div>
                      </Box>
                    );
                  }}
                  sx={{
                    width: "300px",
                    "& .MuiAutocomplete-popupIndicator": {
                      display: "none",
                    },
                    "& .MuiAutocomplete-clearIndicator": {
                      display: "none",
                    },
                  }}
                />
              </Stack>
            </Grid>

            {/* <Grid item xs={12} sm={6} md={6}>
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Agent Group
                </Typography>
                <Select
                  value={agentGroup}
                  autoFocus
                  onChange={(e) => setAgentGroup(e.target.value)}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    border: "1px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": {
                        borderColor: "black !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black !important",
                      },
                    },
                    color: "black",
                  }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "gray" }}>
                          Select Agent Group
                        </span>
                      );
                    }
                    return selected;
                  }}
                >
                  {leadSource.map((item) => (
                    <MenuItem value={item.id} key={item.id}>
                      {item.ticket_group}
                    </MenuItem>
                  ))}
                </Select>
              </Stack>
            </Grid> */}
            <Grid item xs={12} sm={6} md={5}>
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Agent Group
                </Typography>
                <FormControl>
                  <Select
                    multiple
                    displayEmpty
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    sx={{
                      borderRadius: "4px",
                      border: ".5px solid black",
                      boxSizing: "border-box",
                      "& .MuiOutlinedInput-root": {
                        borderColor: "black !important",
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      color: "black",
                    }}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return "Select Agent Group";
                      }

                      return selected.join(", ");
                    }}
                    MenuProps={MenuProps}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    {Array.isArray(leadSource) && leadSource.map((name) => (
                      <MenuItem
                        key={name.id}
                        value={name.ticket_group}
                        style={getStyles(name.ticket_group, personName, theme)}
                      >
                        {name.ticket_group}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
            </Grid>
          </Grid>
          <Grid container sx={{ padding: "15px 0 20px 10px" }}>
            <Grid item sx={11} className="messageFooter">
              <Box className="response" onClick={SaveDate}>
                Save
              </Box>
              <Box className="cancel" onClick={handleClose}>
                Cancel
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
